import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { PaginatedResponse } from '@app/entity';
import { StateService, StateServicePublication, VeteranOrganization } from '@app/entity/social-support';
import { API_VERSION } from '@app/core/api.version';

export interface VeteranOrganizationsFilters {
  search?: string;
  city?: number;
}

@Injectable()
export class SocialSupportService {

  constructor(private http: HttpClient) { }

  getVeteranOrganizations(pageUrl?: string, filters?: VeteranOrganizationsFilters): Observable<PaginatedResponse<VeteranOrganization>> {
    let params = new HttpParams();
    if (filters && filters.search) params = params.set('search', filters.search);
    if (filters && filters.city) params = params.set('city', filters.city + '');
    return this.http.get<PaginatedResponse<VeteranOrganization>>(pageUrl || `/${API_VERSION}/social_supports/organization/`, { params });
  }

  getStateServices(pageUrl?: string, search?: string): Observable<PaginatedResponse<StateService>> {
    let params = new HttpParams();
    if (search) params = params.set('search', search);
    return this.http.get<PaginatedResponse<StateService>>(pageUrl || `/${API_VERSION}/social_supports/state_service/`, { params });
  }

  getStateServicePublications(pageUrl?: string, search?: string): Observable<PaginatedResponse<StateServicePublication>> {
    let params = new HttpParams();
    if (search) params = params.set('search', search);
    return this.http.get<PaginatedResponse<StateService>>(pageUrl || `/${API_VERSION}/social_supports/publications/`, { params });
  }

  getStateServicePublication(slug: string): Observable<StateServicePublication> {
    return this.http.get<StateService>(`/${API_VERSION}/social_supports/publications/${slug}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/social-support.service.ts